export const COUNTRIES = [
  {
      "id": 4,
      "name": "Afghanistan",
      "code": "AF",
      "phoneCode": 93
  },
  {
      "id": 5,
      "name": "Albania",
      "code": "AL",
      "phoneCode": 355
  },
  {
      "id": 6,
      "name": "Algeria",
      "code": "DZ",
      "phoneCode": 213
  },
  {
      "id": 7,
      "name": "American Samoa",
      "code": "AS",
      "phoneCode": 44
  },
  {
      "id": 8,
      "name": "Andorra",
      "code": "AD",
      "phoneCode": 376
  },
  {
      "id": 9,
      "name": "Angola",
      "code": "AO",
      "phoneCode": 244
  },
  {
      "id": 10,
      "name": "Anguilla",
      "code": "AI",
      "phoneCode": 1264
  },
  {
      "id": 12,
      "name": "Antigua and Barbuda",
      "code": "AG",
      "phoneCode": 1268
  },
  {
      "id": 13,
      "name": "Argentina",
      "code": "AR",
      "phoneCode": 54
  },
  {
      "id": 14,
      "name": "Armenia",
      "code": "AM",
      "phoneCode": 374
  },
  {
      "id": 15,
      "name": "Aruba",
      "code": "AW",
      "phoneCode": 297
  },
  {
      "id": 16,
      "name": "Australia",
      "code": "AU",
      "phoneCode": 61
  },
  {
      "id": 17,
      "name": "Austria",
      "code": "AT",
      "phoneCode": 43
  },
  {
      "id": 18,
      "name": "Azerbaijan",
      "code": "AZ",
      "phoneCode": 994
  },
  {
      "id": 19,
      "name": "Bahamas",
      "code": "BS",
      "phoneCode": 1242
  },
  {
      "id": 20,
      "name": "Bahrain",
      "code": "BH",
      "phoneCode": 973
  },
  {
      "id": 21,
      "name": "Bangladesh",
      "code": "BD",
      "phoneCode": 880
  },
  {
      "id": 22,
      "name": "Barbados",
      "code": "BB",
      "phoneCode": 1246
  },
  {
      "id": 23,
      "name": "Belarus",
      "code": "BY",
      "phoneCode": 375
  },
  {
      "id": 24,
      "name": "Belgium",
      "code": "BE",
      "phoneCode": 32
  },
  {
      "id": 25,
      "name": "Belize",
      "code": "BZ",
      "phoneCode": 501
  },
  {
      "id": 26,
      "name": "Benin",
      "code": "BJ",
      "phoneCode": 229
  },
  {
      "id": 27,
      "name": "Bermuda",
      "code": "BM",
      "phoneCode": 1441
  },
  {
      "id": 28,
      "name": "Bhutan",
      "code": "BT",
      "phoneCode": 975
  },
  {
      "id": 29,
      "name": "Bolivia",
      "code": "BO",
      "phoneCode": 591
  },
  {
      "id": 30,
      "name": "Bosnia and Herzegovina",
      "code": "BA",
      "phoneCode": 387
  },
  {
      "id": 31,
      "name": "Botswana",
      "code": "BW",
      "phoneCode": 267
  },
  {
      "id": 32,
      "name": "Bouvet Island",
      "code": "BV",
      "phoneCode": 44
  },
  {
      "id": 33,
      "name": "Brazil",
      "code": "BR",
      "phoneCode": 55
  },
  {
      "id": 35,
      "name": "Brunei Darussalam",
      "code": "BN",
      "phoneCode": 673
  },
  {
      "id": 36,
      "name": "Bulgaria",
      "code": "BG",
      "phoneCode": 359
  },
  {
      "id": 37,
      "name": "Burkina Faso",
      "code": "BF",
      "phoneCode": 226
  },
  {
      "id": 38,
      "name": "Burundi",
      "code": "BI",
      "phoneCode": 257
  },
  {
      "id": 39,
      "name": "Cambodia",
      "code": "KH",
      "phoneCode": 855
  },
  {
      "id": 40,
      "name": "Cameroon",
      "code": "CM",
      "phoneCode": 237
  },
  {
      "id": 3,
      "name": "Canada",
      "code": "CA",
      "phoneCode": 1
  },
  {
      "id": 41,
      "name": "Cape Verde",
      "code": "CV",
      "phoneCode": 238
  },
  {
      "id": 42,
      "name": "Cayman Islands",
      "code": "KY",
      "phoneCode": 1345
  },
  {
      "id": 43,
      "name": "Central African Republic",
      "code": "CF",
      "phoneCode": 236
  },
  {
      "id": 44,
      "name": "Chad",
      "code": "TD",
      "phoneCode": 235
  },
  {
      "id": 45,
      "name": "Chile",
      "code": "CL",
      "phoneCode": 56
  },
  {
      "id": 46,
      "name": "China",
      "code": "CN",
      "phoneCode": 86
  },
  {
      "id": 47,
      "name": "Christmas Island",
      "code": "CX",
      "phoneCode": 61
  },
  {
      "id": 48,
      "name": "Cocos (Keeling) Islands",
      "code": "CC",
      "phoneCode": 61
  },
  {
      "id": 49,
      "name": "Colombia",
      "code": "CO",
      "phoneCode": 57
  },
  {
      "id": 50,
      "name": "Comoros",
      "code": "KM",
      "phoneCode": 269
  },
  {
      "id": 51,
      "name": "Congo",
      "code": "CG",
      "phoneCode": 242
  },
  {
      "id": 52,
      "name": "Cook Islands",
      "code": "CK",
      "phoneCode": 682
  },
  {
      "id": 53,
      "name": "Costa Rica",
      "code": "CR",
      "phoneCode": 506
  },
  {
      "id": 54,
      "name": "Croatia (Hrvatska)",
      "code": "HR",
      "phoneCode": 385
  },
  {
      "id": 55,
      "name": "Cuba",
      "code": "CU",
      "phoneCode": 53
  },
  {
      "id": 56,
      "name": "Cyprus",
      "code": "CY",
      "phoneCode": 357
  },
  {
      "id": 57,
      "name": "Czech Republic",
      "code": "CZ",
      "phoneCode": 420
  },
  {
      "id": 58,
      "name": "Denmark",
      "code": "DK",
      "phoneCode": 45
  },
  {
      "id": 59,
      "name": "Djibouti",
      "code": "DJ",
      "phoneCode": 253
  },
  {
      "id": 60,
      "name": "Dominica",
      "code": "DM",
      "phoneCode": 1767
  },
  {
      "id": 61,
      "name": "Dominican Republic",
      "code": "DO",
      "phoneCode": 1809
  },
  {
      "id": 62,
      "name": "East Timor",
      "code": "TL",
      "phoneCode": 44
  },
  {
      "id": 63,
      "name": "Ecuador",
      "code": "EC",
      "phoneCode": 593
  },
  {
      "id": 64,
      "name": "Egypt",
      "code": "EG",
      "phoneCode": 20
  },
  {
      "id": 65,
      "name": "El Salvador",
      "code": "SV",
      "phoneCode": 503
  },
  {
      "id": 66,
      "name": "Equatorial Guinea",
      "code": "GQ",
      "phoneCode": 240
  },
  {
      "id": 67,
      "name": "Eritrea",
      "code": "ER",
      "phoneCode": 291
  },
  {
      "id": 68,
      "name": "Estonia",
      "code": "EE",
      "phoneCode": 372
  },
  {
      "id": 69,
      "name": "Ethiopia",
      "code": "ET",
      "phoneCode": 251
  },
  {
      "id": 70,
      "name": "Falkland Islands (Malvinas)",
      "code": "FK",
      "phoneCode": 500
  },
  {
      "id": 71,
      "name": "Faroe Islands",
      "code": "FO",
      "phoneCode": 298
  },
  {
      "id": 72,
      "name": "Fiji",
      "code": "FJ",
      "phoneCode": 679
  },
  {
      "id": 73,
      "name": "Finland",
      "code": "FI",
      "phoneCode": 358
  },
  {
      "id": 74,
      "name": "France",
      "code": "FR",
      "phoneCode": 33
  },
  {
      "id": 76,
      "name": "French Guiana",
      "code": "GF",
      "phoneCode": 44
  },
  {
      "id": 77,
      "name": "French Polynesia",
      "code": "PF",
      "phoneCode": 689
  },
  {
      "id": 78,
      "name": "French Southern Territories",
      "code": "TF",
      "phoneCode": 44
  },
  {
      "id": 79,
      "name": "Gabon",
      "code": "GA",
      "phoneCode": 241
  },
  {
      "id": 80,
      "name": "Gambia",
      "code": "GM",
      "phoneCode": 220
  },
  {
      "id": 81,
      "name": "Georgia",
      "code": "GE",
      "phoneCode": 995
  },
  {
      "id": 82,
      "name": "Germany",
      "code": "DE",
      "phoneCode": 49
  },
  {
      "id": 83,
      "name": "Ghana",
      "code": "GH",
      "phoneCode": 233
  },
  {
      "id": 84,
      "name": "Gibraltar",
      "code": "GI",
      "phoneCode": 350
  },
  {
      "id": 85,
      "name": "Greece",
      "code": "GR",
      "phoneCode": 30
  },
  {
      "id": 86,
      "name": "Greenland",
      "code": "GL",
      "phoneCode": 299
  },
  {
      "id": 87,
      "name": "Grenada",
      "code": "GD",
      "phoneCode": 1473
  },
  {
      "id": 88,
      "name": "Guadeloupe",
      "code": "GP",
      "phoneCode": 44
  },
  {
      "id": 89,
      "name": "Guam",
      "code": "GU",
      "phoneCode": 1671
  },
  {
      "id": 90,
      "name": "Guatemala",
      "code": "GT",
      "phoneCode": 502
  },
  {
      "id": 91,
      "name": "Guinea",
      "code": "GN",
      "phoneCode": 224
  },
  {
      "id": 92,
      "name": "Guinea-Bissau",
      "code": "GW",
      "phoneCode": 245
  },
  {
      "id": 93,
      "name": "Guyana",
      "code": "GY",
      "phoneCode": 592
  },
  {
      "id": 94,
      "name": "Haiti",
      "code": "HT",
      "phoneCode": 509
  },
  {
      "id": 95,
      "name": "Heard and Mc Donald Islands",
      "code": "HM",
      "phoneCode": 44
  },
  {
      "id": 96,
      "name": "Honduras",
      "code": "HN",
      "phoneCode": 504
  },
  {
      "id": 97,
      "name": "Hong Kong",
      "code": "HK",
      "phoneCode": 852
  },
  {
      "id": 98,
      "name": "Hungary",
      "code": "HU",
      "phoneCode": 36
  },
  {
      "id": 99,
      "name": "Iceland",
      "code": "IS",
      "phoneCode": 354
  },
  {
      "id": 100,
      "name": "India",
      "code": "IN",
      "phoneCode": 91
  },
  {
      "id": 101,
      "name": "Indonesia",
      "code": "ID",
      "phoneCode": 62
  },
  {
      "id": 102,
      "name": "Iran (Islamic Republic of)",
      "code": "IR",
      "phoneCode": 98
  },
  {
      "id": 103,
      "name": "Iraq",
      "code": "IQ",
      "phoneCode": 964
  },
  {
      "id": 104,
      "name": "Ireland",
      "code": "IE",
      "phoneCode": 353
  },
  {
      "id": 105,
      "name": "Israel",
      "code": "IL",
      "phoneCode": 972
  },
  {
      "id": 1,
      "name": "Italy",
      "code": "IT",
      "phoneCode": 39
  },
  {
      "id": 106,
      "name": "Ivory Coast",
      "code": "CI",
      "phoneCode": 225
  },
  {
      "id": 107,
      "name": "Jamaica",
      "code": "JM",
      "phoneCode": 1876
  },
  {
      "id": 108,
      "name": "Japan",
      "code": "JP",
      "phoneCode": 81
  },
  {
      "id": 109,
      "name": "Jordan",
      "code": "JO",
      "phoneCode": 962
  },
  {
      "id": 110,
      "name": "Kazakhstan",
      "code": "KZ",
      "phoneCode": 7
  },
  {
      "id": 111,
      "name": "Kenya",
      "code": "KE",
      "phoneCode": 254
  },
  {
      "id": 112,
      "name": "Kiribati",
      "code": "KI",
      "phoneCode": 686
  },
  {
      "id": 113,
      "name": "Korea, Democratic People's Republic of",
      "code": "KP",
      "phoneCode": 850
  },
  {
      "id": 114,
      "name": "Korea, Republic of",
      "code": "KR",
      "phoneCode": 82
  },
  {
      "id": 240,
      "name": "Kosovo",
      "code": "XK",
      "phoneCode": 381
  },
  {
      "id": 115,
      "name": "Kuwait",
      "code": "KW",
      "phoneCode": 965
  },
  {
      "id": 116,
      "name": "Kyrgyzstan",
      "code": "KG",
      "phoneCode": 996
  },
  {
      "id": 117,
      "name": "Lao People's Democratic Republic",
      "code": "LA",
      "phoneCode": 856
  },
  {
      "id": 118,
      "name": "Latvia",
      "code": "LV",
      "phoneCode": 371
  },
  {
      "id": 119,
      "name": "Lebanon",
      "code": "LB",
      "phoneCode": 961
  },
  {
      "id": 120,
      "name": "Lesotho",
      "code": "LS",
      "phoneCode": 266
  },
  {
      "id": 121,
      "name": "Liberia",
      "code": "LR",
      "phoneCode": 231
  },
  {
      "id": 122,
      "name": "Libyan Arab Jamahiriya",
      "code": "LY",
      "phoneCode": 218
  },
  {
      "id": 123,
      "name": "Liechtenstein",
      "code": "LI",
      "phoneCode": 423
  },
  {
      "id": 124,
      "name": "Lithuania",
      "code": "LT",
      "phoneCode": 370
  },
  {
      "id": 125,
      "name": "Luxembourg",
      "code": "LU",
      "phoneCode": 352
  },
  {
      "id": 126,
      "name": "Macau",
      "code": "MO",
      "phoneCode": 853
  },
  {
      "id": 127,
      "name": "Macedonia",
      "code": "MK",
      "phoneCode": 389
  },
  {
      "id": 128,
      "name": "Madagascar",
      "code": "MG",
      "phoneCode": 261
  },
  {
      "id": 129,
      "name": "Malawi",
      "code": "MW",
      "phoneCode": 265
  },
  {
      "id": 130,
      "name": "Malaysia",
      "code": "MY",
      "phoneCode": 60
  },
  {
      "id": 131,
      "name": "Maldives",
      "code": "MV",
      "phoneCode": 960
  },
  {
      "id": 132,
      "name": "Mali",
      "code": "ML",
      "phoneCode": 223
  },
  {
      "id": 133,
      "name": "Malta",
      "code": "MT",
      "phoneCode": 356
  },
  {
      "id": 134,
      "name": "Marshall Islands",
      "code": "MH",
      "phoneCode": 692
  },
  {
      "id": 135,
      "name": "Martinique",
      "code": "MQ",
      "phoneCode": 44
  },
  {
      "id": 136,
      "name": "Mauritania",
      "code": "MR",
      "phoneCode": 222
  },
  {
      "id": 137,
      "name": "Mauritius",
      "code": "MU",
      "phoneCode": 230
  },
  {
      "id": 138,
      "name": "Mayotte",
      "code": "YT",
      "phoneCode": 262
  },
  {
      "id": 139,
      "name": "Mexico",
      "code": "MX",
      "phoneCode": 52
  },
  {
      "id": 140,
      "name": "Micronesia, Federated States of",
      "code": "FM",
      "phoneCode": 691
  },
  {
      "id": 141,
      "name": "Moldova, Republic of",
      "code": "MD",
      "phoneCode": 373
  },
  {
      "id": 142,
      "name": "Monaco",
      "code": "MC",
      "phoneCode": 377
  },
  {
      "id": 143,
      "name": "Mongolia",
      "code": "MN",
      "phoneCode": 976
  },
  {
      "id": 241,
      "name": "Montenegro",
      "code": "ME",
      "phoneCode": 382
  },
  {
      "id": 144,
      "name": "Montserrat",
      "code": "MS",
      "phoneCode": 1664
  },
  {
      "id": 145,
      "name": "Morocco",
      "code": "MA",
      "phoneCode": 212
  },
  {
      "id": 146,
      "name": "Mozambique",
      "code": "MZ",
      "phoneCode": 258
  },
  {
      "id": 147,
      "name": "Myanmar",
      "code": "MM",
      "phoneCode": 95
  },
  {
      "id": 148,
      "name": "Namibia",
      "code": "NA",
      "phoneCode": 264
  },
  {
      "id": 149,
      "name": "Nauru",
      "code": "NR",
      "phoneCode": 674
  },
  {
      "id": 150,
      "name": "Nepal",
      "code": "NP",
      "phoneCode": 977
  },
  {
      "id": 151,
      "name": "Netherlands",
      "code": "NL",
      "phoneCode": 31
  },
  {
      "id": 153,
      "name": "New Caledonia",
      "code": "NC",
      "phoneCode": 687
  },
  {
      "id": 154,
      "name": "New Zealand",
      "code": "NZ",
      "phoneCode": 64
  },
  {
      "id": 155,
      "name": "Nicaragua",
      "code": "NI",
      "phoneCode": 505
  },
  {
      "id": 156,
      "name": "Niger",
      "code": "NE",
      "phoneCode": 227
  },
  {
      "id": 157,
      "name": "Nigeria",
      "code": "NG",
      "phoneCode": 234
  },
  {
      "id": 158,
      "name": "Niue",
      "code": "NU",
      "phoneCode": 683
  },
  {
      "id": 159,
      "name": "Norfork Island",
      "code": "NF",
      "phoneCode": 44
  },
  {
      "id": 160,
      "name": "Northern Mariana Islands",
      "code": "MP",
      "phoneCode": 1670
  },
  {
      "id": 161,
      "name": "Norway",
      "code": "NO",
      "phoneCode": 47
  },
  {
      "id": 162,
      "name": "Oman",
      "code": "OM",
      "phoneCode": 968
  },
  {
      "id": 163,
      "name": "Pakistan",
      "code": "PK",
      "phoneCode": 92
  },
  {
      "id": 164,
      "name": "Palau",
      "code": "PW",
      "phoneCode": 680
  },
  {
      "id": 165,
      "name": "Panama",
      "code": "PA",
      "phoneCode": 507
  },
  {
      "id": 166,
      "name": "Papua New Guinea",
      "code": "PG",
      "phoneCode": 675
  },
  {
      "id": 167,
      "name": "Paraguay",
      "code": "PY",
      "phoneCode": 595
  },
  {
      "id": 168,
      "name": "Peru",
      "code": "PE",
      "phoneCode": 51
  },
  {
      "id": 169,
      "name": "Philippines",
      "code": "PH",
      "phoneCode": 63
  },
  {
      "id": 170,
      "name": "Pitcairn",
      "code": "PN",
      "phoneCode": 870
  },
  {
      "id": 171,
      "name": "Poland",
      "code": "PL",
      "phoneCode": 48
  },
  {
      "id": 172,
      "name": "Portugal",
      "code": "PT",
      "phoneCode": 351
  },
  {
      "id": 173,
      "name": "Puerto Rico",
      "code": "PR",
      "phoneCode": 1
  },
  {
      "id": 174,
      "name": "Qatar",
      "code": "QA",
      "phoneCode": 974
  },
  {
      "id": 175,
      "name": "Reunion",
      "code": "RE",
      "phoneCode": 44
  },
  {
      "id": 176,
      "name": "Romania",
      "code": "RO",
      "phoneCode": 40
  },
  {
      "id": 177,
      "name": "Russian Federation",
      "code": "RU",
      "phoneCode": 7
  },
  {
      "id": 178,
      "name": "Rwanda",
      "code": "RW",
      "phoneCode": 250
  },
  {
      "id": 198,
      "name": "Saint Helena",
      "code": "SH",
      "phoneCode": 290
  },
  {
      "id": 179,
      "name": "Saint Kitts and Nevis",
      "code": "KN",
      "phoneCode": 1869
  },
  {
      "id": 180,
      "name": "Saint Lucia",
      "code": "LC",
      "phoneCode": 1758
  },
  {
      "id": 181,
      "name": "Saint Vincent and the Grenadines",
      "code": "VC",
      "phoneCode": 1784
  },
  {
      "id": 199,
      "name": "Saint-Pierre and Miquelon",
      "code": "PM",
      "phoneCode": 508
  },
  {
      "id": 182,
      "name": "Samoa",
      "code": "WS",
      "phoneCode": 685
  },
  {
      "id": 183,
      "name": "San Marino",
      "code": "SM",
      "phoneCode": 378
  },
  {
      "id": 184,
      "name": "Sao Tome and Principe",
      "code": "ST",
      "phoneCode": 239
  },
  {
      "id": 185,
      "name": "Saudi Arabia",
      "code": "SA",
      "phoneCode": 966
  },
  {
      "id": 186,
      "name": "Senegal",
      "code": "SN",
      "phoneCode": 221
  },
  {
      "id": 242,
      "name": "Serbia",
      "code": "RS",
      "phoneCode": 381
  },
  {
      "id": 187,
      "name": "Seychelles",
      "code": "SC",
      "phoneCode": 248
  },
  {
      "id": 188,
      "name": "Sierra Leone",
      "code": "SL",
      "phoneCode": 232
  },
  {
      "id": 189,
      "name": "Singapore",
      "code": "SG",
      "phoneCode": 65
  },
  {
      "id": 190,
      "name": "Slovakia",
      "code": "SK",
      "phoneCode": 421
  },
  {
      "id": 191,
      "name": "Slovenia",
      "code": "SI",
      "phoneCode": 386
  },
  {
      "id": 192,
      "name": "Solomon Islands",
      "code": "SB",
      "phoneCode": 677
  },
  {
      "id": 193,
      "name": "Somalia",
      "code": "SO",
      "phoneCode": 252
  },
  {
      "id": 194,
      "name": "South Africa",
      "code": "ZA",
      "phoneCode": 27
  },
  {
      "id": 195,
      "name": "South Georgia South Sandwich Islands",
      "code": "GS",
      "phoneCode": 44
  },
  {
      "id": 196,
      "name": "Spain",
      "code": "ES",
      "phoneCode": 34
  },
  {
      "id": 197,
      "name": "Sri Lanka",
      "code": "LK",
      "phoneCode": 94
  },
  {
      "id": 200,
      "name": "Sudan",
      "code": "SD",
      "phoneCode": 249
  },
  {
      "id": 201,
      "name": "Suriname",
      "code": "SR",
      "phoneCode": 597
  },
  {
      "id": 203,
      "name": "Swaziland",
      "code": "SZ",
      "phoneCode": 268
  },
  {
      "id": 204,
      "name": "Sweden",
      "code": "SE",
      "phoneCode": 46
  },
  {
      "id": 205,
      "name": "Switzerland",
      "code": "CH",
      "phoneCode": 41
  },
  {
      "id": 206,
      "name": "Syrian Arab Republic",
      "code": "SY",
      "phoneCode": 963
  },
  {
      "id": 207,
      "name": "Taiwan",
      "code": "TW",
      "phoneCode": 886
  },
  {
      "id": 208,
      "name": "Tajikistan",
      "code": "TJ",
      "phoneCode": 992
  },
  {
      "id": 209,
      "name": "Tanzania, United Republic of",
      "code": "TZ",
      "phoneCode": 255
  },
  {
      "id": 210,
      "name": "Thailand",
      "code": "TH",
      "phoneCode": 66
  },
  {
      "id": 211,
      "name": "Togo",
      "code": "TG",
      "phoneCode": 228
  },
  {
      "id": 212,
      "name": "Tokelau",
      "code": "TK",
      "phoneCode": 690
  },
  {
      "id": 213,
      "name": "Tonga",
      "code": "TO",
      "phoneCode": 676
  },
  {
      "id": 214,
      "name": "Trinidad and Tobago",
      "code": "TT",
      "phoneCode": 1868
  },
  {
      "id": 215,
      "name": "Tunisia",
      "code": "TN",
      "phoneCode": 216
  },
  {
      "id": 216,
      "name": "Turkey",
      "code": "TR",
      "phoneCode": 90
  },
  {
      "id": 217,
      "name": "Turkmenistan",
      "code": "TM",
      "phoneCode": 993
  },
  {
      "id": 218,
      "name": "Turks and Caicos Islands",
      "code": "TC",
      "phoneCode": 1649
  },
  {
      "id": 219,
      "name": "Tuvalu",
      "code": "TV",
      "phoneCode": 688
  },
  {
      "id": 220,
      "name": "Uganda",
      "code": "UG",
      "phoneCode": 256
  },
  {
      "id": 221,
      "name": "Ukraine",
      "code": "UA",
      "phoneCode": 380
  },
  {
      "id": 222,
      "name": "United Arab Emirates",
      "code": "AE",
      "phoneCode": 971
  },
  {
      "id": 223,
      "name": "United Kingdom",
      "code": "GB",
      "phoneCode": 44
  },
  {
      "id": 2,
      "name": "United States",
      "code": "US",
      "phoneCode": 1
  },
  {
      "id": 224,
      "name": "United States minor outlying islands",
      "code": "UM",
      "phoneCode": 44
  },
  {
      "id": 225,
      "name": "Uruguay",
      "code": "UY",
      "phoneCode": 598
  },
  {
      "id": 226,
      "name": "Uzbekistan",
      "code": "UZ",
      "phoneCode": 998
  },
  {
      "id": 227,
      "name": "Vanuatu",
      "code": "VU",
      "phoneCode": 678
  },
  {
      "id": 228,
      "name": "Vatican City State",
      "code": "VA",
      "phoneCode": 39
  },
  {
      "id": 229,
      "name": "Venezuela",
      "code": "VE",
      "phoneCode": 58
  },
  {
      "id": 230,
      "name": "Vietnam",
      "code": "VN",
      "phoneCode": 84
  },
  {
      "id": 232,
      "name": "Virgin Islands (US)",
      "code": "VI",
      "phoneCode": 1340
  },
  {
      "id": 231,
      "name": "Virigan Islands (British)",
      "code": "VG",
      "phoneCode": 1284
  },
  {
      "id": 233,
      "name": "Wallis and Futuna Islands",
      "code": "WF",
      "phoneCode": 681
  },
  {
      "id": 235,
      "name": "Yemen",
      "code": "YE",
      "phoneCode": 967
  },
  {
      "id": 238,
      "name": "Zambia",
      "code": "ZM",
      "phoneCode": 260
  },
  {
      "id": 239,
      "name": "Zimbabwe",
      "code": "ZW",
      "phoneCode": 263
  }
]